import React, { useState, useEffect} from "react";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import Styles from "./styles.module.scss";
import { TabStrip } from "@progress/kendo-react-layout";
import Tab from "../../components/tab";
import DropDown from '../../components/dropdown';
import classnames from "classnames"; 
import Button from "../../components/button";
import { Icon } from "@iconify/react"; 
import crownIcon from "../../assets/images/crown_gray_icon.svg";
import FulltimeDetails from "../../modal/fullTimeDetails";
import { getFullTimeMetadata, updateFulltimejobDetails } from './services';
import FulltimeInfoModal from "../../modal/fullTimeInfoModal";
import PopOver from "../../components/popover"

function ClosedFullTime(props: any){

    const [pageNumber , setPageNumber] = useState<number>(1)
    const [count , setCount] = useState<any>()
    const [pageSize , setPageSize] = useState<number>(25)
    const [incontractList, setIncontractlist] = useState<any>()
    const [selected, setSelected] = useState<number>(0)
    const [show, setShow] = useState<boolean>()
    const [expand, setExpand] = useState<boolean>(false)
    const [rowNumber, setRowNumber] = useState<number>()
    const [infoModal , setInfoModal] = useState<boolean>(false)
    const [candidateJobId , setCandiateJobId] = useState<string>('')
    const [fulltimeModalData, setFulltimeModalData] = useState<any>()

    useEffect(() => {
        setIncontractlist(props.data)
        setCount(props.total)
      }, [props])

    const pageChange = (decision: string) => {
        let page = pageNumber
        if (decision === 'Add'){
          setPageNumber(pageNumber + 1)
          page = page + 1
        }else {
          setPageNumber(pageNumber - 1)
          page = page - 1
        }
        // props.handlePageChange(pageSize, page)
      }

      const datachange = (e: any) => {
        setPageSize(e.value)
        // props.handlePageChange(e.value, pageNumber)
      }

      const rowClick = (contractHistory: any) => {
        let data = {
            candidateJobId: contractHistory.candidateJobId
        }
        getFullTimeMetadata(data).then((resp: any) => {
            if(resp && resp.status === 1){
                setFulltimeModalData(resp.data)
                setInfoModal(true)
                setCandiateJobId(contractHistory && contractHistory.candidateJobId)
            }
        })
       }

       const submmitFUlltimeDetails = ( data: any) => {

        data.contractId = fulltimeModalData[0].contractMetadata.contractId
        let value = {
            "candidateId": fulltimeModalData[0].candidateId,
            "userLoginId": localStorage.getItem('loginId'),
            "jobId": fulltimeModalData[0].jobId,
            "submittedBy":  "RECRUITER",
            "fullTimeMetadata": data,
            "historyFlag": false,
            "candidateJobId": candidateJobId
          }
          updateFulltimejobDetails(value).then((resp: any) => {
            setInfoModal(false)
            setShow(false)
            props.getTablesValues();
          })
       }
    
    const openInNewTab = (url: any) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
      
    const redirection = (candidateLoginId: string) => {
        localStorage.setItem('candidateLoginId', candidateLoginId);
        localStorage.setItem('ResourcesCandidateLoginId', candidateLoginId);
        localStorage.setItem('ResourcesTab', '6');
        openInNewTab(`${window.location.origin}/createResources`)
    }

    const certificationCell = (data: any) => {
        let ellowScreeningCertifications = data
        let skillcombine = ellowScreeningCertifications && ellowScreeningCertifications.map((dataskill: any) => {
          return dataskill.skills && dataskill.skills.name;
        }
        ).join(",");
        return (
          <td>
            <div className={Styles.positionStstus}>
              <PopOver title={skillcombine}
                position="Bottom">
                {ellowScreeningCertifications && ellowScreeningCertifications.map((skillData: any, key: any) => {
                  return (<div key={key} className={Styles.positionList}>   <span className={Styles.dotStatus}/><strong>{skillData.skills && skillData.skills.name} - {skillData.certificationType} </strong> </div>);
                })}
              </PopOver>
            </div>
          </td>
        )
      }
       
    return(
        <div className={Styles.companyList} >
                { infoModal && <FulltimeInfoModal onClose={() => setInfoModal(false)} ClickHandler={submmitFUlltimeDetails} defaultvalues={fulltimeModalData} buttonName={'Edit'} allocatedTo={props.allocatedTo} allRecruiters={props.allRecruiters}/>}
            <div className="staticPagination">
                <a href=" " className={pageNumber === 1 ? "k-link k-pager-nav k-disabled" : "k-link k-pager-nav"} title="Go to the previous page">
                    <span className="k-icon k-i-arrow-60-left" onClick={(e) => {pageChange('Remove'); e.preventDefault()}}></span>
                </a>
                <a href=" " className={((pageNumber - 1) * pageSize + 1 >= count || count <= pageSize) ? "k-link k-pager-nav k-disabled" : "k-link k-pager-nav"} title="Go to the next page">
                    <span className="k-icon k-i-arrow-60-right" onClick={(e) => { pageChange('Add'); e.preventDefault()}}></span>
                </a>
                Rows per page: <DropDown data={[25, 50, 100]} defaultValue="25" onChange={(e: any) => datachange(e)}/> {`${pageNumber === 1 ? 1 : (pageNumber - 1) * pageSize + 1}-${count < pageSize ? count : pageSize < ((pageNumber - 1) * pageSize + 1) ? ((pageNumber) * pageSize)  : pageSize } of ${count}`}
            </div>
            {incontractList && incontractList.map((item: any, key:number) => {
                return(
                    <div key={key} className={classnames((selected === key && show) ? Styles.itemActive : Styles.itemInactive)}>
                        <div className={Styles.companyItem}>
                            <div className={Styles.actionButton}>
                            {(selected === key && show) ? <Button onClick={() => { setShow((prev) => !prev); setSelected(key)}}><Icon icon="akar-icons:minus" /></Button>
                            : 
                            <Button onClick={() => { setSelected(key); setShow(true); props.onClick(item.loginId)}} ><Icon icon="akar-icons:plus" /></Button>
                            } 
                            </div>
                            <div className={classnames(Styles.infoCard, Styles.infoCardMain)} onClick={() => redirection(item.loginId)}>
                            { item.googleProfileImage ? 
                                <figure><img src={item.googleProfileImage}/></figure> : 
                                <figure className={Styles.noImage}>{item.firstName && item.firstName[0]}{item.lastName && item.lastName[0]}</figure>}
                                <h2>{item.name}
                                <span>{item.phoneNumber ? item.email : ''}</span>
                                <span>{item.phoneNumber ? item.phoneNumber : ''}</span>
                                    {/* <span>{item.skills && item.skills.toString() }</span> */}
                                </h2>
                            </div>
                            <div className={Styles.infoCard}>
                                <figure className={Styles.iconFig}> <img src={crownIcon} /></figure>
                                <h4>
                                    Availability
                                <span>{item.experience} Years</span>
                                </h4>
                            </div>
                            <div className={Styles.infoCard}>
                                <figure className={Styles.iconFig}> <img src={crownIcon} /></figure>
                                <h4>
                                    Certification
                                    <span>{certificationCell(item.ellowScreeningCertifications)}</span>
                                </h4>
                            </div>
                            <div className={Styles.infoCard}>
                                <figure className={Styles.iconFig}><Icon icon="lucide:award" /></figure>
                                <h4>
                                    Ellow status
                                <span>{item.ellowStatus}</span>
                                </h4>
                            </div>
                            {/* <div className={Styles.infoCard}>
                                <figure className={Styles.iconFig}><Icon icon="lucide:award" /></figure>
                                <h4>
                                    Job title
                                <span>{item.PositionName}</span>
                                </h4>
                            </div>
                            <div className={Styles.infoCard}>
                                <figure className={Styles.iconFig}><Icon icon="lucide:award" /></figure>
                                <h4>
                                    Company name
                                <span></span>
                                </h4>
                            </div>
                            <div className={Styles.infoCard}>
                                <figure className={Styles.iconFig}><Icon icon="lucide:award" /></figure>
                                <h4>
                                    Closed on
                                <span></span>
                                </h4>
                            </div> */}
                        </div>
                        <div className={Styles.detailtable}>
                            <section className="tableStyle no-padd-top">
                                <div className={Styles.expandableTable}>
                                    <div className={Styles.tableItemWrap}>
                                        <table>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th className={Styles.width135}>Job title</th>
                                                <th className={Styles.width180}>Company name</th>
                                                <th className={Styles.width150}>Closed on</th>
                                                {/* <th className={Styles.width180}>Notice period of the candidate in weeks</th>
                                                <th className={Styles.width150}>Date of joining</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td colSpan={9}  className={classnames(Styles.tdWrap, Styles.tdWrapActive)}>
                                                {props.contractHistory && props.contractHistory.length > 0 && props.contractHistory.map((item: any, key: number) => {
                                                    return (
                                                        <>
                                                        <table>
                                                        <tr>
                                                        <td width="100">
                                                            {/* <span className={checkStatus(props.contractHistory[key].action).class}>{checkStatus(props.contractHistory[key].action).value}</span> */}
                                                            <div className={Styles.expand}>
                                                                <Icon key={key} icon={expand && key === rowNumber ? "ep:arrow-down-bold" : 'ep:arrow-up-bold'} onClick={() => { setExpand(!expand); setRowNumber(key)}} />
                                                                </div>
                                                            </td>
                                                            <td width="280">{item.position}</td>
                                                            <td width="360">{item.companyName}</td>
                                                            <td>{new Date( parseInt(item.dateOfJoining)).toDateString().slice(3) }</td>
                                                            <td>
                                                            <div className={Styles.info}>
                                                                <Icon icon="lucide:info" onClick={() => rowClick(props && props.contractHistory[key])}/>
                                                            </div>
                                                            </td>
                                                        </tr>
                                                        </table>
                                                        </>
                                                    )
                                                    })
                                                    } 
                                                </td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                )
            })}
        </div>
    )

}

export default ClosedFullTime;